import {Component, OnInit, OnDestroy, Output, EventEmitter} from '@angular/core';
import { ApiService } from '../api.service';
import { Router } from '@angular/router';
import { StoreService } from '../store.service';
import { PlatformLocation } from '@angular/common';
import {CommonService} from '../common.service';
type NextStep = Array<string> | number;

@Component({
  selector: 'app-user-available-asking',
  templateUrl: './user-available-asking.component.html',
  styleUrls: ['./user-available-asking.component.css']
})
export class UserAvailableAskingComponent implements OnInit, OnDestroy {
  @Output() outPutHeartBeatStatus = new EventEmitter<any>();
  constructor(private commonService:CommonService,private router:Router,private location:PlatformLocation,private apiService:ApiService,private storeService:StoreService) { }
  askImmediately:any;
  timer:any = null;
  timeOneMinuteAgo:string = "";
  //控制对话框的样式
  dialogDisplay:string = 'none';
  dialogOpacity:number = 0;
  authInvalid:boolean;
  courseInvalid:boolean;
  nextStep:NextStep;
  // Stephen add 2025-03-07
  isTencent: boolean = false;
  openDialog(){
    if(this.authInvalid){
      //设置时间,其他地方登录
      let timeStaOneMinAge = new Date().valueOf() - 60*1000;
      let date = new Date(timeStaOneMinAge)
      let hours = date.getHours();
      let minutes = date.getMinutes();
      let hoursStr = hours < 10 ? '0'+hours : hours;
      let minutesStr = minutes < 10 ? '0'+minutes : minutes;
      this.timeOneMinuteAgo = `${hoursStr}:${minutesStr}`;
      this.outPutHeartBeatStatus.emit(false);
    }
    this.dialogDisplay = 'block';
		setTimeout(()=>{
			this.dialogOpacity = 1
		},0)
  }
  closeDialog(){
		this.dialogOpacity = 0;
		setTimeout(()=>{
			this.dialogDisplay = 'none';
		},0)
  }
  openCourseInvalidBox(){
    this.courseInvalid = true;
    this.openDialog();
  }

  // status===0 时，需同时确认 coachAuthority 为 false 才视为账号过期可弹窗
  shouldShowAccountExpiredByAuthority(): Promise<boolean> {
    return this.commonService.getUserCheckAuthority().then(result => {
      const shouldShow = !(result && result.coachAuthority);
      console.log('---checkAuthority coachAuthority:', result && result.coachAuthority, '是否弹窗:', shouldShow);
      return shouldShow;
    }).catch(err => {
      console.log('---checkAuthority 请求失败，不弹账号过期窗', err);
      return false;
    });
  }

  checkValidAccountDoSth(){
    this.apiService.getCompanyList().subscribe(result => {
      const validCompanyList = result.filter(item=>item.state === 1);
      const validCount = validCompanyList.length;
      if(validCount > 1){
        this.nextStep = ['course-select'];
        this.openCourseInvalidBox()
      }else if(validCount === 1){
        this.nextStep = validCompanyList[0].id;
        this.openCourseInvalidBox()
      }else{
        //导航至404页面
        this.goToLearnigMapOrNothingPage()
      }
    })
  }
  startAtimer(duration:number){
    clearTimeout(this.timer);//先清除timer执行环境
    this.timer = setTimeout(()=>{
      console.log('---当前用户状态轮询一次')
      //请求当前user的id接口
      //如果请求失败（401）则会被全局的监测捕获未授权状态，不必继续轮询
      this.apiService.getUserInfo().subscribe(res=>{
        //处理当前课程状态
        if(res && res.status === 0){
          //无效用户：再校验教练权限，无权限才弹
          this.shouldShowAccountExpiredByAuthority().then(shouldShow => {
            if(shouldShow){
              this.checkValidAccountDoSth()
            }
          });
        }
        if(res && res.status === 1){
          localStorage.setItem('userId',res.id);
          $('#userIdContainer').val(res.id);
          this.storeService.notification.refreshHomePage.next(true)
        }
        if(res && !('id' in res)){
          //userId关联失败,其他地方登录
          this.openDialog();//打开重定向倒计时模态
          return;
        }

        this.startAtimer(duration);//下一次轮询
      })
    },duration)
  }
  getAskingDuration(){
    return new Promise((resolve,rejection)=>{
      this.apiService.getUserStatusAskingDuration().subscribe(res=>{
        resolve(res)
      })
    })
  }
  goToLoginPage(){
    this.closeDialog();//关闭对话框
    //还原状态
    this.initTipState();
    this.router.navigate(['new-login']);
    this.commonService.removeStorage('transtalen-token');
    this.commonService.removeStorage('transtalenuserid');
    //还原授权状态为初始值null
    this.storeService.notification.notAuthed.next(null)
  }
  goToLearnigMapOrNothingPage(){
    if(this.location.pathname === '/learning-map'){
      //已经在首页了。刷新一下,确保出现nothing-page
      (this.location as any).location.reload()
    }else{
      //go to home page
      this.router.navigate(['learning-map'])
    }
  }
  goToLearnigMapOrCourseSelect(){
    this.closeDialog();//关闭对话框
    //还原状态
    this.initTipState();
    this.goToLoginPage()
    //判断应该去哪里
    // if(Array.isArray(this.nextStep)){
    //   //路径
    //   this.router.navigate(this.nextStep)
    // }else if(typeof this.nextStep === 'number'){
    //   //是公司ID
    //   this.loginWithCompanyIdDirectly(this.nextStep)
    // }else{
    //   this.goToLearnigMapOrNothingPage()
    // }
  }
  loginWithCompanyIdDirectly(companyId){
    let loginData = {};
    try {
      loginData = JSON.parse(localStorage.getItem('loginData') || '{}');
    } catch (e) {
      loginData = {};
    }
    const token = localStorage.getItem('transtalen-token');
    const sendData = this.commonService.buildCompanyReloginPayload(loginData, companyId, {
      switchCompany: !!token,
      token: token || ''
    });
    this.apiService.loginInPhoneOrAccount(sendData, { withToken: !!token }).subscribe(result => {
      this.goToLearnigMapOrNothingPage()
    })
  }
  initTipState(){
    this.authInvalid = false;
    this.courseInvalid = false;
  }
  checkValidAccountDoSthNotReloadpage(){
    console.log('---checkValidAccountDoSthNotReloadpage 被调用')
    this.apiService.getCompanyList().subscribe(result => {
      const validCompanyList = result.filter(item=>item.state === 1);
      const validCount = validCompanyList.length;
      console.log('---有效公司数量:', validCount)
      if(validCount > 1){
        this.nextStep = ['course-select'];
        console.log('---多个有效公司，准备弹窗')
        this.openCourseInvalidBox()
      }else if(validCount === 1){
        this.nextStep = validCompanyList[0].id;
        console.log('---一个有效公司，准备弹窗')
        this.openCourseInvalidBox()
      }else{
        console.log('---没有有效公司，弹出账号失效提示')
        // 没有有效公司时，弹出登录失效的提示
        this.authInvalid = true;
        this.openDialog();
      }
    })
  }
  initAskImmediately(){
    this.askImmediately = this.storeService.notification.askImmediately.subscribe(value=>{
      if(value === true){
        console.log('learning-map页立即询问一次---')
        //需要立即执行一次
        this.apiService.getUserInfo().subscribe(res=>{
          //处理当前课程状态
          if(res && res.status === 0){
            //无效用户：再校验教练权限，无权限才弹
            this.shouldShowAccountExpiredByAuthority().then(shouldShow => {
              if(shouldShow){
                this.checkValidAccountDoSthNotReloadpage()
              }
            });
          }

          if(res && !('id' in res)){
            //userId关联失败,其他地方登录
            this.openDialog();//打开重定向倒计时模态
            return;
          }
        })
      }
    })
  }

  ngOnInit() {
    this.isTencent = this.commonService.checkAndSetModuleId();
    this.initAskImmediately();
    
    // 立即执行一次用户状态检查
    this.checkUserStatusImmediately();
    
    // 获取轮询间隔并启动定时器
    this.getAskingDuration().then(res=>{
     console.log('message:轮询间隔为---',res);
     this.startAtimer(res as number*1000);
    })
    //监听全部接口的未授权通知
    this.storeService.notification.notAuthed.subscribe(d=>{
      if(d === true){
        console.log('接口未授权,在其他地方登录-----',d)
        this.authInvalid = true;
        this.openDialog();//打开重定向倒计时模态
      }
    })
  }
  
  // 立即检查用户状态
  checkUserStatusImmediately(){
    console.log('---组件初始化，立即检查用户状态一次')
    this.apiService.getUserInfo().subscribe(res=>{
      console.log('---getUserInfo 返回结果:', res)
      //处理当前课程状态
      if(res && res.status === 0){
        console.log('---用户状态为0（无效用户），校验 coachAuthority')
        //无效用户：再校验教练权限，无权限才弹账号过期
        this.shouldShowAccountExpiredByAuthority().then(shouldShow => {
          if(shouldShow){
            console.log('---coachAuthority 为 false，立即弹窗')
            this.courseInvalid = true;
            this.openDialog();
          }else{
            console.log('---coachAuthority 为 true，不弹账号过期窗')
          }
        });
        return;
      }
      if(res && res.status === 1){
        console.log('---用户状态为1（正常用户）')
        //正常用户
        localStorage.setItem('userId',res.id);
        $('#userIdContainer').val(res.id);
        this.storeService.notification.refreshHomePage.next(true)
        return;
      }
      if(res && !('id' in res)){
        console.log('---用户无id（其他地方登录），立即弹窗')
        //userId关联失败,其他地方登录
        this.authInvalid = true;
        this.openDialog();//打开重定向倒计时模态
        return;
      }
    })
  }
  ngOnDestroy(){
    this.askImmediately.unsubscribe();//取消订阅
    clearTimeout(this.timer);
    console.log('---清除当前用户状态轮询');
  }
}



// WEBPACK FOOTER //
// ./src/app/user-available-asking/user-available-asking.component.ts